<template>
    <div>
        <v-container fluid pa-0>
            <v-card elevation="0">
                <v-container fluid grid-list-xl class="toolbar-container">
                    <v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
                        <v-toolbar color="grey lighten-3" elevation="1">
                            <bc-btn-back></bc-btn-back>
                            <v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <!-- <bc-tooltip>
                                <template slot="activator">
                                    <v-btn icon @click="showNonconformanceHoldTag(nonconformance && $isSet(nonconformance.hold_tag_id) ? true : false)"
                                        ><v-icon :color="$isSet(nonconformance.hold_tag_id) ? nonconformance.hold_tag_class : 'black'">{{
                                            nonconformance.hold_tag_icon
                                        }}</v-icon></v-btn
                                    >
                                </template>
                                {{ $isSet(nonconformance.hold_tag_id) ? $t("lang.viewHoldTag") : $t("lang.addHoldTag") }}
                            </bc-tooltip>
                            <bc-tooltip>
                                <template slot="activator">
                                    <v-btn
                                        icon
                                        @click="
                                            getScrapAuthorization(nonconformance && $isSet(nonconformance.scrap_auth_id) ? nonconformance.scrap_auth_id : null)
                                        "
                                        ><v-icon :color="nonconformance.scrap_auth_id != null ? nonconformance.scrap_class : 'black'">{{
                                            nonconformance.scrap_icon
                                        }}</v-icon></v-btn
                                    >
                                </template>
                                {{ nonconformance.scrap_auth_id != null ? $t("lang.viewScrapAuth") : $t("lang.addScrapAuth") }}
                            </bc-tooltip> -->
                            <bc-btn-refresh @invoke-method="refresh(true)"></bc-btn-refresh>
                            <bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobileList"></bc-btn-mobile-nav>
                        </v-toolbar>
                    </v-layout>
                </v-container>
                <v-container grid-list-xl>
                    <v-layout row :wrap="$bp.smallScreen">
                        <v-flex xs12 md4 lg3 align-self-start pb-0 :pl-0="!$bp.smallScreen">
                            <v-layout row wrap>
                                <v-flex xs6 py-0>
                                    <v-chip
                                        style="text-transform: none"
                                        round
                                        :color="nonconformance.stop_loading == '1' ? 'error' : 'success'"
                                        text-color="white"
                                    >
                                        <v-icon color="white" class="mr-2" v-model="nonconformance.stop_loading">{{
                                            nonconformance.stop_loading == "1" ? "cancel" : "check_circle"
                                        }}</v-icon>
                                        <span class="white--text">{{
                                            status_loader
                                                ? $t("lang.loading")
                                                : nonconformance.stop_loading == "1"
                                                ? $t("lang.do_stop_loading")
                                                : $t("lang.dont_stop_loading")
                                        }}</span>
                                    </v-chip>
                                </v-flex>
                                <v-flex xs6 pr-0 py-0>
                                    <div class="ml-auto">
                                        <bc-tooltip>
                                            <template slot="activator">
                                                <v-btn @mouseup.left="showNonconformancePrinter()" icon>
                                                    <v-icon color="indigo">print</v-icon>
                                                </v-btn>
                                            </template>
                                            {{ $t("lang.print_nonconformance") }}
                                        </bc-tooltip>
                                        <bc-tooltip perm="companies.update">
                                            <template slot="activator">
                                                <v-btn @mouseup.left="showNonconformance(nonconformance)" icon>
                                                    <v-icon color="indigo">edit</v-icon>
                                                </v-btn>
                                            </template>
                                            {{ $t("lang.edit_nonconformance") }}
                                        </bc-tooltip>
                                    </div>
                                </v-flex>
                            </v-layout>
                            <bc-list prepend-icon="info" prepend-position="top" :perm="false" icon-color="primary">
                                <template>
                                    <v-container pa-2>
                                        <v-layout row wrap>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.location_found")}:` }}</v-flex>
                                            <v-flex xs5 fw-bold mt-1>{{ nonconformance.object_name_display || "---" }}</v-flex>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.supervisor_notified")}:` }}</v-flex>
                                            <v-flex xs5 fw-bold mt-1>{{ nonconformance.notify_supervisor == "1" ? $t("lang.yes") : $t("lang.no") }}</v-flex>
                                            <v-flex xs7 mt-1 v-if="nonconformance.notify_supervisor == '0'">{{ `${$t("lang.not_notified_reason")}:` }}</v-flex>
                                            <v-flex xs5 fw-bold mt-1 v-if="nonconformance.notify_supervisor == '0'">{{
                                                nonconformance.not_notified_reason || "---"
                                            }}</v-flex>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.supervisor_name")}:` }}</v-flex>
                                            <v-flex xs5 fw-bold mt-1>{{ nonconformance.supervisor_name || "---" }}</v-flex>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.reported_time")}:` }}</v-flex>
                                            <v-flex xs5 fw-bold mt-1>{{ nonconformance.date_created || "---" }}</v-flex>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.fc")}:` }}</v-flex>
                                            <v-flex xs5 fw-bold mt-1>{{ nonconformance.fc == "1" ? $t("lang.yes") : $t("lang.no") }}</v-flex>
                                            <v-flex xs7 mt-1 v-if="nonconformance.fc == '0'">{{ `${$t("lang.not_fc_reason")}:` }}</v-flex>
                                            <v-flex xs5 fw-bold mt-1 v-if="nonconformance.fc == '0'">{{ nonconformance.not_fc_reason || "---" }}</v-flex>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.qc_hold")}:` }}</v-flex>
                                            <v-flex xs5 fw-bold mt-1>{{ nonconformance.qc_hold == "1" ? $t("lang.yes") : $t("lang.no") }}</v-flex>
                                            <v-flex xs7 mt-1 v-if="nonconformance.qc_hold == '0'">{{ `${$t("lang.not_qc_reason")}:` }}</v-flex>
                                            <v-flex xs5 fw-bold mt-1 v-if="nonconformance.qc_hold == '0'">{{ nonconformance.not_qc_reason || "---" }}</v-flex>

                                            <v-flex xs7 mt-1>{{ `${$t("lang.batch_number")}:` }}</v-flex>
                                            <v-flex xs5 fw-bold mt-1
                                                ><span
                                                    v-if="nonconformance && nonconformance.batch_control_id"
                                                    style="cursor: pointer"
                                                    @click.stop="$copyToClipboard(nonconformance.batch_control_id)"
                                                >
                                                    <bc-tooltip>
                                                        <template slot="activator">
                                                            <span>{{ $textTruncate(nonconformance.batch_control_id, 15) }}</span>
                                                            <v-icon class="fw-light ml-1" small>content_copy</v-icon>
                                                        </template>
                                                        Copy Batch Control #
                                                    </bc-tooltip></span
                                                >
                                                <span v-else>---</span></v-flex
                                            >
                                            <v-flex xs7 mt-1>{{ `${$t("lang.who_found")}:` }}</v-flex>
                                            <v-flex xs5 fw-bold mt-1>{{ nonconformance.created_by || "---" }}</v-flex>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.customer")}:` }}</v-flex>
                                            <v-flex xs5 fw-bold mt-1>{{ nonconformance.company || "---" }}</v-flex>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.part_name")}:` }}</v-flex>
                                            <v-flex xs5 fw-bold mt-1>{{ nonconformance.part_name || "---" }}</v-flex>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.part_number")}:` }}</v-flex>
                                            <v-flex xs5 fw-bold mt-1>{{ nonconformance.customer_part_number || "---" }}</v-flex>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.description")}:` }}</v-flex>
                                            <v-flex xs5 fw-bold mt-1>{{ nonconformance.description || "---" }}</v-flex>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.prod_shift_super")}:` }}</v-flex>
                                            <v-flex xs5 fw-bold mt-1>{{ nonconformance.prod_shift_super_name || "---" }}</v-flex>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.prod_super")}:` }}</v-flex>
                                            <v-flex xs5 fw-bold mt-1>{{ nonconformance.prod_super_name || "---" }}</v-flex>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.prod_asst_mgr")}:` }}</v-flex>
                                            <v-flex xs5 fw-bold mt-1>{{ nonconformance.prod_asst_mgr_name || "---" }}</v-flex>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.prod_mgr")}:` }}</v-flex>
                                            <v-flex xs5 fw-bold mt-1>{{ nonconformance.prod_mgr_name || "---" }}</v-flex>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.qc_mgr")}:` }}</v-flex>
                                            <v-flex xs5 fw-bold mt-1>{{ nonconformance.qc_mgr_name || "---" }}</v-flex>
                                            <v-flex xs7 mt-1>{{ `${$t("lang.charge")}:` }}</v-flex>
                                            <v-flex xs5 fw-bold mt-1>{{ nonconformance.charge == "1" ? "Yes" : "No" || "---" }}</v-flex>
                                            <!-- <v-flex xs8 mt-1>{{ `${$t("lang.lot_number")}:` }}</v-flex>
                                            <v-flex xs4 fw-bold mt-1>{{ nonconformance.lot_number || "---" }}</v-flex> -->
                                        </v-layout>
                                    </v-container>
                                </template>
                            </bc-list>
                        </v-flex>
                        <v-divider vertical class="mt-0 mb-0" inset v-if="!$bp.smallScreen"></v-divider>
                        <v-flex xs12 md8 lg9 :pr-0="!$bp.smallScreen" :pl-4="!$bp.smallScreen" align-self-start>
                            <v-layout row wrap>
                                <!-- <v-flex xs12>
                                    <v-textarea v-model="nonconformance.description" label="Description" rows="1" auto-grow v-readonly-click></v-textarea>
                                </v-flex> -->
                                <v-flex xs12>
                                    <v-card>
                                        <v-card-title>
                                            <h3 class="headline">
                                                <strong>{{ $isSet(nonconformance.hold_tag_id) ? $t("lang.hold_tag") : $t("lang.no_hold_tag") }}</strong>
                                            </h3>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                v-if="$isSet(nonconformance.hold_tag_id)"
                                                icon
                                                @mouseup.left="showHoldTagPrinter(nonconformance.hold_tag_id ? nonconformance.hold_tag_id : '')"
                                            >
                                                <v-icon color="indigo">print</v-icon>
                                            </v-btn>
                                            <v-btn
                                                icon
                                                @mouseup.left="
                                                    showNonconformanceHoldTag(nonconformance && $isSet(nonconformance.hold_tag_id) ? true : false, true)
                                                "
                                            >
                                                <v-icon color="indigo">{{ $isSet(nonconformance.hold_tag_id) ? "edit" : "add" }}</v-icon>
                                            </v-btn>
                                        </v-card-title>

                                        <v-card-text v-if="$isSet(nonconformance.hold_tag_id)">
                                            <v-container grid-list-form>
                                                <v-layout row wrap v-readonly-click>
                                                    <v-flex xs12 style="height: 100%">
                                                        <v-layout row wrap>
                                                            <!-- <v-flex xs4>
                                                                <v-text-field
                                                                    :label="`${$t('lang.internal_id')}`"
                                                                    :value="
                                                                        nonconformance_hold_tag && nonconformance_hold_tag.internal_id
                                                                            ? nonconformance_hold_tag.internal_id
                                                                            : '---'
                                                                    "
                                                                    disabled
                                                                ></v-text-field>
                                                            </v-flex>
                                                            <v-flex xs4>
                                                                <v-text-field
                                                                    :label="`${$t('lang.part_number')}`"
                                                                    :value="
                                                                        nonconformance_hold_tag && nonconformance_hold_tag.customer_part_number
                                                                            ? nonconformance_hold_tag.customer_part_number
                                                                            : '---'
                                                                    "
                                                                    disabled
                                                                ></v-text-field>
                                                            </v-flex>
                                                            <v-flex xs4>
                                                                <v-text-field
                                                                    :label="`${$t('lang.customer')}`"
                                                                    :value="
                                                                        nonconformance_hold_tag && nonconformance_hold_tag.company_id
                                                                            ? nonconformance_hold_tag.company_name
                                                                            : '---'
                                                                    "
                                                                    disabled
                                                                ></v-text-field>
                                                            </v-flex> -->
                                                            <v-flex xs12>
                                                                <v-textarea
                                                                    v-model="nonconformance_hold_tag.reason"
                                                                    :label="`${$t('lang.reason_for_hold_tag')} *`"
                                                                    auto-grow
                                                                    rows="1"
                                                                    :rules="ifValid('nonconformance_hold_tags.reason')"
                                                                ></v-textarea>
                                                            </v-flex>
                                                            <v-flex xs6>
                                                                <h3><strong>QC Dept. use only</strong></h3>
                                                            </v-flex>
                                                            <v-flex xs6></v-flex>
                                                            <v-flex xs6>
                                                                <v-checkbox
                                                                    style="margin-top: 0px !important"
                                                                    :value="$isSet(nonconformance_hold_tag.verified_by)"
                                                                    label="QC verified abnormal condition"
                                                                    hide-details
                                                                ></v-checkbox>
                                                            </v-flex>
                                                            <v-flex xs3>
                                                                <bc-date-picker
                                                                    v-model="nonconformance_hold_tag.verified_date"
                                                                    :label="$t('lang.date')"
                                                                    :rules="ifValid('nonconformance_hold_tags.verified_date')"
                                                                ></bc-date-picker>
                                                            </v-flex>
                                                            <v-flex xs3>
                                                                <bc-autocomplete
                                                                    v-model="nonconformance_hold_tag.verified_by"
                                                                    :label="$t('lang.by')"
                                                                    :items="people_options"
                                                                    item-value="user_id"
                                                                    item-text="combined_name"
                                                                    :rules="ifValid('nonconformance_hold_tags.verified_by')"
                                                                ></bc-autocomplete>
                                                            </v-flex>
                                                            <v-flex xs6>
                                                                <h3><strong>Request to Production</strong></h3>
                                                            </v-flex>
                                                            <v-flex xs6>
                                                                <h3><strong>Production Dept. use only</strong></h3>
                                                            </v-flex>
                                                            <v-flex xs6>
                                                                <bc-select
                                                                    v-model="nonconformance_hold_tag.nine_point_submission"
                                                                    :label="`${$t('lang.nine_point_submission')} *`"
                                                                    :items="[
                                                                        { value: '1', text: $t('lang.yes') },
                                                                        { value: '0', text: $t('lang.no') },
                                                                    ]"
                                                                    item-value="value"
                                                                    item-text="text"
                                                                    :rules="ifValid('nonconformance_hold_tags.nine_point_submission')"
                                                                >
                                                                </bc-select>
                                                            </v-flex>
                                                            <v-flex xs3>
                                                                <bc-date-picker
                                                                    v-model="nonconformance_hold_tag.nine_point_submission_date"
                                                                    :label="$t('lang.date')"
                                                                    :rules="ifValid('nonconformance_hold_tags.nine_point_submission_date')"
                                                                ></bc-date-picker>
                                                            </v-flex>
                                                            <v-flex xs3>
                                                                <bc-autocomplete
                                                                    v-model="nonconformance_hold_tag.nine_point_submission_by"
                                                                    :label="$t('lang.by')"
                                                                    :items="people_options"
                                                                    item-value="user_id"
                                                                    item-text="combined_name"
                                                                    :rules="ifValid('nonconformance_hold_tags.nine_point_submission_by')"
                                                                ></bc-autocomplete>
                                                            </v-flex>
                                                            <v-flex xs6>
                                                                <bc-select
                                                                    v-model="nonconformance_hold_tag.strip_chart"
                                                                    :label="`${$t('lang.strip_chart')} *`"
                                                                    :items="[
                                                                        { value: '1', text: $t('lang.yes') },
                                                                        { value: '0', text: $t('lang.no') },
                                                                    ]"
                                                                    item-value="value"
                                                                    item-text="text"
                                                                    :rules="ifValid('nonconformance_hold_tags.strip_chart')"
                                                                >
                                                                </bc-select>
                                                            </v-flex>
                                                            <v-flex xs3>
                                                                <bc-date-picker
                                                                    v-model="nonconformance_hold_tag.strip_chart_date"
                                                                    :label="$t('lang.date')"
                                                                    :rules="ifValid('nonconformance_hold_tags.strip_chart_date')"
                                                                ></bc-date-picker>
                                                            </v-flex>
                                                            <v-flex xs3>
                                                                <bc-autocomplete
                                                                    v-model="nonconformance_hold_tag.strip_chart_by"
                                                                    :label="$t('lang.by')"
                                                                    :items="people_options"
                                                                    item-value="user_id"
                                                                    item-text="combined_name"
                                                                    :rules="ifValid('nonconformance_hold_tags.strip_chart_by')"
                                                                ></bc-autocomplete>
                                                            </v-flex>
                                                            <v-flex xs6>
                                                                <bc-select
                                                                    v-model="nonconformance_hold_tag.recipe_sheet"
                                                                    :label="`${$t('lang.recipe_sheet')} *`"
                                                                    :items="[
                                                                        { value: '1', text: $t('lang.yes') },
                                                                        { value: '0', text: $t('lang.no') },
                                                                    ]"
                                                                    item-value="value"
                                                                    item-text="text"
                                                                    :rules="ifValid('nonconformance_hold_tags.recipe_sheet')"
                                                                >
                                                                </bc-select>
                                                            </v-flex>
                                                            <v-flex xs3>
                                                                <bc-date-picker
                                                                    v-model="nonconformance_hold_tag.recipe_sheet_date"
                                                                    :label="$t('lang.date')"
                                                                    :rules="ifValid('nonconformance_hold_tags.recipe_sheet_date')"
                                                                ></bc-date-picker>
                                                            </v-flex>
                                                            <v-flex xs3>
                                                                <bc-autocomplete
                                                                    v-model="nonconformance_hold_tag.recipe_sheet_by"
                                                                    :label="$t('lang.by')"
                                                                    :items="people_options"
                                                                    item-value="user_id"
                                                                    item-text="combined_name"
                                                                    :rules="ifValid('nonconformance_hold_tags.recipe_sheet_by')"
                                                                ></bc-autocomplete>
                                                            </v-flex>
                                                            <v-flex xs6>
                                                                <bc-select
                                                                    v-model="nonconformance_hold_tag.process_sheet"
                                                                    :label="`${$t('lang.process_sheet')} *`"
                                                                    :items="[
                                                                        { value: '1', text: $t('lang.yes') },
                                                                        { value: '0', text: $t('lang.no') },
                                                                    ]"
                                                                    item-value="value"
                                                                    item-text="text"
                                                                    :rules="ifValid('nonconformance_hold_tags.process_sheet')"
                                                                >
                                                                </bc-select>
                                                            </v-flex>
                                                            <v-flex xs3>
                                                                <bc-date-picker
                                                                    v-model="nonconformance_hold_tag.process_sheet_date"
                                                                    :label="$t('lang.date')"
                                                                    :rules="ifValid('nonconformance_hold_tags.process_sheet_date')"
                                                                ></bc-date-picker>
                                                            </v-flex>
                                                            <v-flex xs3>
                                                                <bc-autocomplete
                                                                    v-model="nonconformance_hold_tag.process_sheet_by"
                                                                    :label="$t('lang.by')"
                                                                    :items="people_options"
                                                                    item-value="user_id"
                                                                    item-text="combined_name"
                                                                    :rules="ifValid('nonconformance_hold_tags.process_sheet_by')"
                                                                ></bc-autocomplete>
                                                            </v-flex>
                                                            <v-flex xs6>
                                                                <h3><strong>QC Dept. use only</strong></h3>
                                                            </v-flex>
                                                            <v-flex xs6></v-flex>
                                                            <v-flex xs6>
                                                                <v-checkbox
                                                                    style="margin-top: 0px !important"
                                                                    :value="$isSet(nonconformance_hold_tag.customer_contacted_by)"
                                                                    label="Customer Contacted"
                                                                    hide-details
                                                                    @click="setNull($event)"
                                                                ></v-checkbox>
                                                            </v-flex>
                                                            <v-flex xs3>
                                                                <bc-date-picker
                                                                    v-model="nonconformance_hold_tag.customer_contacted_date"
                                                                    :label="$t('lang.date')"
                                                                    :rules="ifValid('nonconformance_hold_tags.customer_contacted_date')"
                                                                ></bc-date-picker>
                                                            </v-flex>
                                                            <v-flex xs3>
                                                                <bc-autocomplete
                                                                    v-model="nonconformance_hold_tag.customer_contacted_by"
                                                                    :label="$t('lang.by')"
                                                                    :items="people_options"
                                                                    item-value="user_id"
                                                                    item-text="combined_name"
                                                                    :rules="ifValid('nonconformance_hold_tags.customer_contacted_by')"
                                                                ></bc-autocomplete>
                                                            </v-flex>
                                                        </v-layout>
                                                    </v-flex>
                                                </v-layout>
                                            </v-container>
                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                                <v-flex xs12>
                                    <v-card>
                                        <v-card-title>
                                            <h3 class="headline">
                                                <strong>{{
                                                    $isSet(nonconformance.scrap_auth_id) ? $t("lang.scrap_authorization") : $t("lang.no_scrap_auth")
                                                }}</strong>
                                            </h3>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                v-if="$isSet(nonconformance.scrap_auth_id)"
                                                icon
                                                @mouseup.left="showScrapAuthPrinter(nonconformance.scrap_auth_id ? nonconformance.scrap_auth_id : '')"
                                            >
                                                <v-icon color="indigo">print</v-icon>
                                            </v-btn>
                                            <v-btn
                                                icon
                                                @mouseup.left="
                                                    getScrapAuthorization(
                                                        nonconformance && $isSet(nonconformance.scrap_auth_id) ? nonconformance.scrap_auth_id : null
                                                    )
                                                "
                                            >
                                                <v-icon color="indigo">{{ $isSet(nonconformance.scrap_auth_id) ? "edit" : "add" }}</v-icon>
                                            </v-btn>
                                        </v-card-title>
                                        <v-card-text v-if="$isSet(nonconformance.scrap_auth_id)">
                                            <v-container grid-list-form>
                                                <v-layout row wrap v-readonly-click>
                                                    <v-flex style="display: none">
                                                        <v-text-field
                                                            v-model="scrap_authorization.scrap_auth_id"
                                                            :label="`${$t('lang.scrap_auth_id')} *`"
                                                            :counter="showCounter(scrap_authorization.scrap_auth_id, 'scrap_authorizations.scrap_auth_id')"
                                                            :rules="ifValid('scrap_authorizations.scrap_auth_id')"
                                                        ></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs6>
                                                        <v-text-field
                                                            v-model="scrap_authorization.nonconformance_id"
                                                            :label="$t('lang.authorization_id')"
                                                            :rules="ifValid('scrap_authorizations.nonconformance_id')"
                                                            disabled
                                                        ></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs6>
                                                        <v-text-field
                                                            v-model="scrap_authorization.batch_id"
                                                            :label="$t('lang.batch_id')"
                                                            :rules="ifValid('scrap_authorizations.batch_id')"
                                                            disabled
                                                        ></v-text-field>
                                                    </v-flex>

                                                    <v-flex xs6>
                                                        <v-text-field
                                                            v-model="scrap_authorization.company"
                                                            :label="$t('lang.customer')"
                                                            disabled
                                                        ></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs6>
                                                        <v-text-field
                                                            v-model="scrap_authorization.part_id"
                                                            :label="$t('lang.part_id')"
                                                            :rules="ifValid('scrap_authorizations.part_id')"
                                                            disabled
                                                        ></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs5>
                                                        <v-switch
                                                            style="margin-top: 0px !important"
                                                            v-model="scrap_authorization.corrective_action"
                                                            :label="
                                                                scrap_authorization.corrective_action == '1' ? $t('lang.in_process') : $t('lang.not_in_process')
                                                            "
                                                            true-value="1"
                                                            false-value="0"
                                                        ></v-switch>
                                                    </v-flex>
                                                    <v-flex xs7>
                                                        <v-text-field
                                                            v-if="scrap_authorization.corrective_action == '1'"
                                                            v-model="scrap_authorization.car_number"
                                                            :label="$t('lang.car_number')"
                                                            :counter="showCounter(scrap_authorization.car_number, 'scrap_authorizations.car_number')"
                                                            :rules="ifValid('scrap_authorizations.car_number')"
                                                        ></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs8>
                                                        <bc-autocomplete
                                                            v-model="scrap_authorization.quality_mgr_id"
                                                            :label="$t('lang.quality_mgr_id')"
                                                            :items="people_options"
                                                            item-value="user_id"
                                                            item-text="combined_name"
                                                            :rules="ifValid('scrap_authorizations.quality_mgr_id')"
                                                        ></bc-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs4>
                                                        <bc-date-picker
                                                            v-model="scrap_authorization.quality_mgr_date"
                                                            :label="$t('lang.quality_mgr_date')"
                                                            :rules="ifValid('scrap_authorizations.quality_mgr_date')"
                                                        ></bc-date-picker>
                                                    </v-flex>
                                                    <v-flex xs8>
                                                        <bc-autocomplete
                                                            v-model="scrap_authorization.sales_mgr_id"
                                                            :label="$t('lang.sales_mgr_id')"
                                                            :items="people_options"
                                                            item-value="user_id"
                                                            item-text="combined_name"
                                                            :rules="ifValid('scrap_authorizations.sales_mgr_id')"
                                                        ></bc-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs4>
                                                        <bc-date-picker
                                                            v-model="scrap_authorization.sales_mgr_date"
                                                            :label="$t('lang.sales_mgr_date')"
                                                            :rules="ifValid('scrap_authorizations.sales_mgr_date')"
                                                        ></bc-date-picker>
                                                    </v-flex>
                                                    <v-flex xs8>
                                                        <bc-autocomplete
                                                            v-model="scrap_authorization.ehs_mgr_id"
                                                            :label="$t('lang.ehs_mgr_id')"
                                                            :items="people_options"
                                                            item-value="user_id"
                                                            item-text="combined_name"
                                                            :rules="ifValid('scrap_authorizations.ehs_mgr_id')"
                                                        ></bc-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs4>
                                                        <bc-date-picker
                                                            v-model="scrap_authorization.ehs_mgr_date"
                                                            :label="$t('lang.ehs_mgr_date')"
                                                            :rules="ifValid('scrap_authorizations.ehs_mgr_date')"
                                                        ></bc-date-picker>
                                                    </v-flex>
                                                    <v-flex xs8>
                                                        <bc-autocomplete
                                                            v-model="scrap_authorization.production_mgr_id"
                                                            :label="$t('lang.production_mgr_id')"
                                                            :items="people_options"
                                                            item-value="user_id"
                                                            item-text="combined_name"
                                                            :rules="ifValid('scrap_authorizations.production_mgr_id')"
                                                        ></bc-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs4>
                                                        <bc-date-picker
                                                            v-model="scrap_authorization.production_mgr_date"
                                                            :label="$t('lang.production_mgr_date')"
                                                            :rules="ifValid('scrap_authorizations.production_mgr_date')"
                                                        ></bc-date-picker>
                                                    </v-flex>
                                                    <v-flex xs8>
                                                        <bc-autocomplete
                                                            v-model="scrap_authorization.executive_id"
                                                            :label="$t('lang.executive_id')"
                                                            :items="people_options"
                                                            item-value="user_id"
                                                            item-text="combined_name"
                                                            :rules="ifValid('scrap_authorizations.executive_id')"
                                                        ></bc-autocomplete>
                                                    </v-flex>
                                                    <v-flex xs4>
                                                        <bc-date-picker
                                                            v-model="scrap_authorization.executive_date"
                                                            :label="$t('lang.executive_date')"
                                                            :rules="ifValid('scrap_authorizations.executive_date')"
                                                        ></bc-date-picker>
                                                    </v-flex>
                                                    <v-flex xs4>
                                                        <v-text-field
                                                            v-model="scrap_authorization.qty_scrapped"
                                                            :label="`${$t('lang.qty_scrapped')} *`"
                                                            :counter="showCounter(scrap_authorization.qty_scrapped, 'scrap_authorizations.qty_scrapped')"
                                                            :rules="ifValid('scrap_authorizations.qty_scrapped')"
                                                        ></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs4>
                                                        <v-text-field
                                                            v-model="scrap_authorization.rma_number"
                                                            :label="$t('lang.rma_number')"
                                                            :counter="showCounter(scrap_authorization.rma_number, 'scrap_authorizations.rma_number')"
                                                            :rules="ifValid('scrap_authorizations.rma_number')"
                                                        ></v-text-field>
                                                    </v-flex>
                                                    <v-flex xs4>
                                                        <v-text-field
                                                            v-model="scrap_authorization.part_cost_estimate"
                                                            :label="$t('lang.part_cost_estimate')"
                                                            :counter="
                                                                showCounter(scrap_authorization.part_cost_estimate, 'scrap_authorizations.part_cost_estimate')
                                                            "
                                                            :rules="ifValid('scrap_authorizations.part_cost_estimate')"
                                                            prefix="$"
                                                        ></v-text-field>
                                                    </v-flex>
                                                </v-layout>
                                            </v-container>
                                        </v-card-text>
                                    </v-card>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
        </v-container>
        <bc-dialog :value="nonconformance_dialog" max-width="800">
            <v-card>
                <v-card-title>
                    <span class="headline">{{
                        currObjField("nonconformance_id")
                            ? currObjField("editable") == "0"
                                ? $t("lang.view_nonconformance")
                                : $t("lang.edit_nonconformance")
                            : $t("lang.add_nonconformance")
                    }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        action="closeNonconformanceDialog"
                        :dialog-status="nonconformance_dialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text>
                    <v-form ref="nonconformance" @submit.prevent>
                        <v-container grid-list-form>
                            <v-layout row wrap :class="{ 'prevent-click': currObjField('nonconformance_id') && currObjField('editable') == '0' }">
                                <v-flex xs12 style="height: 100%">
                                    <v-layout row wrap>
                                        <v-flex xs6>
                                            <bc-select
                                                v-model="current_nonconformance.stop_loading"
                                                :label="`${$t('lang.stop_loading')}`"
                                                :items="[
                                                    { value: '1', text: $t('lang.yes') },
                                                    { value: '0', text: $t('lang.no') },
                                                ]"
                                                item-value="value"
                                                item-text="text"
                                                :rules="ifValid('nonconformance.stop_loading')"
                                            >
                                            </bc-select>
                                        </v-flex>
                                        <v-flex xs6>
                                            <bc-autocomplete
                                                v-model="current_nonconformance.nonconformance_type_id"
                                                :label="`${$t('lang.nonconformance_type')} *`"
                                                :items="nonconformance_types"
                                                item-value="nonconformance_type_id"
                                                item-text="type"
                                                :rules="ifValid('nonconformance.nonconformance_type_id')"
                                            ></bc-autocomplete>
                                        </v-flex>
                                        <v-flex xs6>
                                            <bc-select
                                                v-model="current_nonconformance.notify_supervisor"
                                                :label="`${$t('lang.notify_supervisor')}`"
                                                :items="[
                                                    { value: '1', text: $t('lang.yes') },
                                                    { value: '0', text: $t('lang.no') },
                                                ]"
                                                item-value="value"
                                                item-text="text"
                                                :rules="ifValid('nonconformance.notify_supervisor')"
                                            >
                                            </bc-select>
                                        </v-flex>
                                        <v-flex xs6 v-if="current_nonconformance.notify_supervisor == 0">
                                            <v-text-field
                                                v-model="current_nonconformance.not_notified_reason"
                                                :label="`${$t('lang.not_notified_reason')}`"
                                                :rules="ifValid('nonconformance.not_notified_reason')"
                                            >
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs6 v-if="current_nonconformance.notify_supervisor == 1">
                                            <bc-autocomplete
                                                v-model="current_nonconformance.supervisor_id"
                                                :label="`${$t('lang.supervisor_name')}`"
                                                :items="people_options"
                                                item-value="user_id"
                                                item-text="combined_name"
                                                :rules="ifValid('nonconformance.supervisor_id')"
                                            ></bc-autocomplete>
                                        </v-flex>
                                        <v-flex xs6>
                                            <bc-select
                                                v-model="current_nonconformance.fc"
                                                :label="`${$t('lang.fc')}`"
                                                :items="[
                                                    { value: '1', text: $t('lang.yes') },
                                                    { value: '0', text: $t('lang.no') },
                                                ]"
                                                item-value="value"
                                                item-text="text"
                                                :rules="ifValid('nonconformance.fc')"
                                            >
                                            </bc-select>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-text-field
                                                v-if="current_nonconformance.fc == 0"
                                                v-model="current_nonconformance.not_fc_reason"
                                                :label="`${$t('lang.not_fc_reason')}`"
                                                :rules="ifValid('nonconformance.not_fc_reason')"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs6>
                                            <bc-select
                                                v-model="current_nonconformance.qc_hold"
                                                :label="`${$t('lang.qc_hold')}`"
                                                :items="[
                                                    { value: '1', text: $t('lang.yes') },
                                                    { value: '0', text: $t('lang.no') },
                                                ]"
                                                item-value="value"
                                                item-text="text"
                                                :rules="ifValid('nonconformance.qc_hold')"
                                            >
                                            </bc-select>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-text-field
                                                v-if="current_nonconformance.qc_hold == 0"
                                                v-model="current_nonconformance.not_qc_reason"
                                                :label="`${$t('lang.not_qc_reason')}`"
                                                :rules="ifValid('nonconformance.not_qc_reason')"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs6>
                                            <bc-autocomplete
                                                v-model="current_nonconformance.prod_shift_super_id"
                                                :label="`${$t('lang.prod_shift_super')}`"
                                                :items="people_options"
                                                item-value="user_id"
                                                item-text="combined_name"
                                                :rules="ifValid('nonconformance.prod_shift_super_id')"
                                            ></bc-autocomplete>
                                        </v-flex>
                                        <v-flex xs6>
                                            <bc-autocomplete
                                                v-model="current_nonconformance.prod_super_id"
                                                :label="`${$t('lang.prod_super')}`"
                                                :items="people_options"
                                                item-value="user_id"
                                                item-text="combined_name"
                                                :rules="ifValid('nonconformance.prod_super_id')"
                                            ></bc-autocomplete>
                                        </v-flex>

                                        <v-flex xs6>
                                            <bc-autocomplete
                                                v-model="current_nonconformance.prod_asst_mgr_id"
                                                :label="`${$t('lang.prod_asst_mgr')}`"
                                                :items="people_options"
                                                item-value="user_id"
                                                item-text="combined_name"
                                                :rules="ifValid('nonconformance.prod_asst_mgr_id')"
                                            ></bc-autocomplete>
                                        </v-flex>
                                        <v-flex xs6>
                                            <bc-autocomplete
                                                v-model="current_nonconformance.prod_mgr_id"
                                                :label="`${$t('lang.prod_mgr')}`"
                                                :items="people_options"
                                                item-value="user_id"
                                                item-text="combined_name"
                                                :rules="ifValid('nonconformance.prod_mgr_id')"
                                            ></bc-autocomplete>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-switch
                                                v-model="current_nonconformance.charge"
                                                :label="current_nonconformance.charge == '1' ? $t('lang.charge_yes') : $t('lang.charge_no')"
                                                true-value="1"
                                                false-value="0"
                                            ></v-switch>
                                        </v-flex>
                                        <v-flex xs6>
                                            <bc-autocomplete
                                                v-model="current_nonconformance.qc_mgr_id"
                                                :label="`${$t('lang.qc_mgr')}`"
                                                :items="people_options"
                                                item-value="user_id"
                                                item-text="combined_name"
                                                :rules="ifValid('nonconformance.qc_mgr_id')"
                                            ></bc-autocomplete>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-text-field
                                                small
                                                :label="`${$t('lang.suspect_qty_found')}`"
                                                v-model="current_nonconformance.nonconformance_qty"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-textarea
                                                v-model="current_nonconformance.description"
                                                :label="`${$t('lang.description')} *`"
                                                auto-grow
                                                rows="1"
                                                :rules="ifValid('nonconformance.description')"
                                            ></v-textarea>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        v-if="currObjField('nonconformance_id') && currObjField('editable') == '1' && hasPerm('nonconformance.delete')"
                        color="error"
                        @mouseup.left="$refs.delete_nonconformance.openDialog()"
                        >{{ $t("lang.delete") }}</v-btn
                    >
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="closeNonconformanceDialog()">{{ $t("lang.cancel") }}</v-btn>
                    <v-btn
                        v-if="currObjField('nonconformance_id') || (currObjField('editable') == '1' && hasPerm('nonconformance.update'))"
                        color="success"
                        @mouseup.left="modifyNonconformance(currObjField('nonconformance_id') ? 'patch' : 'post', currObjField('nonconformance_id'))"
                        >{{ $t("lang.save") }}</v-btn
                    >
                </v-card-actions>
            </v-card>
        </bc-dialog>
        <bc-dialog :value="scrap_authorization_dialog" max-width="800">
            <v-card>
                <v-form ref="form_scrap_authorization">
                    <v-card-title>
                        <span class="headline">{{
                            scrap_authorization.scrap_auth_id ? $t("lang.edit_scrap_authorization") : $t("lang.add_scrap_authorization")
                        }}</span>
                        <v-spacer></v-spacer>
                        <bc-btn-dialog-close
                            @invoke-method="invokeMethod($event)"
                            action="closeScrapAuthorizationDialog"
                            :dialog-status="scrap_authorization_dialog"
                        ></bc-btn-dialog-close>
                    </v-card-title>
                    <v-card-text class="pa-2">
                        <v-container grid-list-form>
                            <v-layout row wrap>
                                <v-flex style="display: none">
                                    <v-text-field
                                        v-model="scrap_authorization.scrap_auth_id"
                                        :label="`${$t('lang.scrap_auth_id')} *`"
                                        :counter="showCounter(scrap_authorization.scrap_auth_id, 'scrap_authorizations.scrap_auth_id')"
                                        :rules="ifValid('scrap_authorizations.scrap_auth_id')"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs12>
                                    <v-alert
                                        style="width: 100%; padding: 10px !important; color: black; margin: 0px !important"
                                        :value="true"
                                        type="info"
                                        text-color="black"
                                        color="#f8eea1"
                                        >{{ $t("lang.info_scrap_authorization") }}</v-alert
                                    >
                                </v-flex>
                                <v-flex xs6 v-if="nonconformance.scrap_auth_id">
                                    <v-text-field
                                        v-model="scrap_authorization.nonconformance_id"
                                        :label="$t('lang.nonconformance')"
                                        :rules="ifValid('scrap_authorizations.nonconformance_id')"
                                        disabled
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs6 v-if="nonconformance.scrap_auth_id">
                                    <v-text-field
                                        v-model="scrap_authorization.batch_id"
                                        :label="$t('lang.batch_id')"
                                        :rules="ifValid('scrap_authorizations.batch_id')"
                                        disabled
                                    ></v-text-field>
                                </v-flex>

                                <v-flex xs6 v-if="nonconformance.scrap_auth_id">
                                    <v-text-field v-model="scrap_authorization.company" :label="$t('lang.company_id')" disabled></v-text-field>
                                </v-flex>
                                <v-flex xs6 v-if="nonconformance.scrap_auth_id">
                                    <v-text-field
                                        v-model="scrap_authorization.part_id"
                                        :label="$t('lang.part_id')"
                                        :rules="ifValid('scrap_authorizations.part_id')"
                                        disabled
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs5>
                                    <v-switch
                                        v-model="scrap_authorization.corrective_action"
                                        :label="scrap_authorization.corrective_action == '1' ? $t('lang.in_process') : $t('lang.not_in_process')"
                                        true-value="1"
                                        false-value="0"
                                    ></v-switch>
                                </v-flex>
                                <v-flex xs7>
                                    <v-text-field
                                        v-if="scrap_authorization.corrective_action == '1'"
                                        v-model="scrap_authorization.car_number"
                                        :label="$t('lang.car_number')"
                                        :counter="showCounter(scrap_authorization.car_number, 'scrap_authorizations.car_number')"
                                        :rules="ifValid('scrap_authorizations.car_number')"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs8>
                                    <bc-autocomplete
                                        v-model="scrap_authorization.quality_mgr_id"
                                        :label="$t('lang.quality_mgr_id')"
                                        :items="people_options"
                                        item-value="user_id"
                                        item-text="combined_name"
                                        :rules="ifValid('scrap_authorizations.quality_mgr_id')"
                                    ></bc-autocomplete>
                                </v-flex>
                                <v-flex xs4>
                                    <bc-date-picker
                                        v-model="scrap_authorization.quality_mgr_date"
                                        :label="$t('lang.quality_mgr_date')"
                                        :rules="ifValid('scrap_authorizations.quality_mgr_date')"
                                    ></bc-date-picker>
                                </v-flex>
                                <v-flex xs8>
                                    <bc-autocomplete
                                        v-model="scrap_authorization.sales_mgr_id"
                                        :label="$t('lang.sales_mgr_id')"
                                        :items="people_options"
                                        item-value="user_id"
                                        item-text="combined_name"
                                        :rules="ifValid('scrap_authorizations.sales_mgr_id')"
                                    ></bc-autocomplete>
                                </v-flex>
                                <v-flex xs4>
                                    <bc-date-picker
                                        v-model="scrap_authorization.sales_mgr_date"
                                        :label="$t('lang.sales_mgr_date')"
                                        :rules="ifValid('scrap_authorizations.sales_mgr_date')"
                                    ></bc-date-picker>
                                </v-flex>
                                <v-flex xs8>
                                    <bc-autocomplete
                                        v-model="scrap_authorization.ehs_mgr_id"
                                        :label="$t('lang.ehs_mgr_id')"
                                        :items="people_options"
                                        item-value="user_id"
                                        item-text="combined_name"
                                        :rules="ifValid('scrap_authorizations.ehs_mgr_id')"
                                    ></bc-autocomplete>
                                </v-flex>
                                <v-flex xs4>
                                    <bc-date-picker
                                        v-model="scrap_authorization.ehs_mgr_date"
                                        :label="$t('lang.ehs_mgr_date')"
                                        :rules="ifValid('scrap_authorizations.ehs_mgr_date')"
                                    ></bc-date-picker>
                                </v-flex>
                                <v-flex xs8>
                                    <bc-autocomplete
                                        v-model="scrap_authorization.production_mgr_id"
                                        :label="$t('lang.production_mgr_id')"
                                        :items="people_options"
                                        item-value="user_id"
                                        item-text="combined_name"
                                        :rules="ifValid('scrap_authorizations.production_mgr_id')"
                                    ></bc-autocomplete>
                                </v-flex>
                                <v-flex xs4>
                                    <bc-date-picker
                                        v-model="scrap_authorization.production_mgr_date"
                                        :label="$t('lang.production_mgr_date')"
                                        :rules="ifValid('scrap_authorizations.production_mgr_date')"
                                    ></bc-date-picker>
                                </v-flex>
                                <v-flex xs8>
                                    <bc-autocomplete
                                        v-model="scrap_authorization.executive_id"
                                        :label="$t('lang.executive_id')"
                                        :items="people_options"
                                        item-value="user_id"
                                        item-text="combined_name"
                                        :rules="ifValid('scrap_authorizations.executive_id')"
                                    ></bc-autocomplete>
                                </v-flex>
                                <v-flex xs4>
                                    <bc-date-picker
                                        v-model="scrap_authorization.executive_date"
                                        :label="$t('lang.executive_date')"
                                        :rules="ifValid('scrap_authorizations.executive_date')"
                                    ></bc-date-picker>
                                </v-flex>
                                <v-flex xs4>
                                    <v-text-field
                                        v-model="scrap_authorization.qty_scrapped"
                                        :label="`${$t('lang.qty_scrapped')} *`"
                                        :counter="showCounter(scrap_authorization.qty_scrapped, 'scrap_authorizations.qty_scrapped')"
                                        :rules="ifValid('scrap_authorizations.qty_scrapped')"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs4>
                                    <v-text-field
                                        v-model="scrap_authorization.rma_number"
                                        :label="$t('lang.rma_number')"
                                        :counter="showCounter(scrap_authorization.rma_number, 'scrap_authorizations.rma_number')"
                                        :rules="ifValid('scrap_authorizations.rma_number')"
                                    ></v-text-field>
                                </v-flex>
                                <v-flex xs4>
                                    <v-text-field
                                        v-model="scrap_authorization.part_cost_estimate"
                                        :label="$t('lang.part_cost_estimate')"
                                        :counter="showCounter(scrap_authorization.part_cost_estimate, 'scrap_authorizations.part_cost_estimate')"
                                        :rules="ifValid('scrap_authorizations.part_cost_estimate')"
                                        prefix="$"
                                    ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                            v-if="scrap_authorization.scrap_auth_id"
                            color="primary"
                            @mouseup.left="showScrapAuthPrinter(scrap_authorization.scrap_auth_id)"
                            >{{ $t("lang.print") }}</v-btn
                        >
                        <v-spacer></v-spacer>
                        <v-btn flat @mouseup.left="closeScrapAuthorizationDialog()">{{ $t("lang.cancel") }}</v-btn>

                        <v-btn color="success" @click="saveScrapAuthorizations">{{ $t("lang.save") }}</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </bc-dialog>
        <bc-dialog :value="nonconformance_hold_tag_dialog" max-width="800">
            <v-card>
                <v-card-title>
                    <span class="headline">{{
                        nonconformance_hold_tag && nonconformance_hold_tag.hold_tag_id
                            ? currObjField("editable") == "0"
                                ? $t("lang.view_nonconformance_hold_tag")
                                : $t("lang.edit_nonconformance_hold_tag")
                            : $t("lang.add_nonconformance_hold_tag")
                    }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        action="closeNonconformanceHoldTagDialog"
                        :dialog-status="nonconformance_hold_tag_dialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text>
                    <v-form ref="form_nonconformance_hold_tag" @submit.prevent>
                        <v-container grid-list-form>
                            <v-layout row wrap :class="{ 'prevent-click': currObjField('nonconformance_id') && currObjField('editable') == '0' }">
                                <v-flex xs12 style="height: 100%">
                                    <v-layout row wrap>
                                        <!-- <v-flex xs4>
                                            <v-text-field
                                                :label="`${$t('lang.internal_id')}`"
                                                :value="
                                                    nonconformance_hold_tag && nonconformance_hold_tag.internal_id ? nonconformance_hold_tag.internal_id : '---'
                                                "
                                                disabled
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs4>
                                            <v-text-field
                                                :label="`${$t('lang.part_number')}`"
                                                :value="
                                                    nonconformance_hold_tag && nonconformance_hold_tag.customer_part_number
                                                        ? nonconformance_hold_tag.customer_part_number
                                                        : '---'
                                                "
                                                disabled
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs4>
                                            <v-text-field
                                                :label="`${$t('lang.customer')}`"
                                                :value="
                                                    nonconformance_hold_tag && nonconformance_hold_tag.company_id ? nonconformance_hold_tag.company_name : '---'
                                                "
                                                disabled
                                            ></v-text-field>
                                        </v-flex> -->
                                        <v-flex xs12>
                                            <v-textarea
                                                v-model="nonconformance_hold_tag.reason"
                                                :label="`${$t('lang.reason_for_hold_tag')} *`"
                                                auto-grow
                                                rows="1"
                                                :rules="ifValid('nonconformance_hold_tags.reason')"
                                            ></v-textarea>
                                        </v-flex>
                                        <v-flex xs6>
                                            <h3><strong>QC Dept. use only</strong></h3>
                                        </v-flex>
                                        <v-flex xs6></v-flex>
                                        <v-flex xs6>
                                            <v-checkbox
                                                v-model="qc_verified"
                                                label="QC verified abnormal condition"
                                                true-value="1"
                                                false-value="0"
                                                hide-details
                                                @click="setNull(nonconformance_hold_tag, ['verified_date', 'verified_by'])"
                                            ></v-checkbox>
                                        </v-flex>
                                        <v-flex xs3>
                                            <bc-date-picker
                                                v-if="qc_verified == '1'"
                                                v-model="nonconformance_hold_tag.verified_date"
                                                :label="$t('lang.date')"
                                                :rules="ifValid('nonconformance_hold_tags.verified_date')"
                                            ></bc-date-picker>
                                        </v-flex>
                                        <v-flex xs3>
                                            <bc-autocomplete
                                                v-if="qc_verified == '1'"
                                                v-model="nonconformance_hold_tag.verified_by"
                                                :label="$t('lang.by')"
                                                :items="people_options"
                                                item-value="user_id"
                                                item-text="combined_name"
                                                :rules="ifValid('nonconformance_hold_tags.verified_by')"
                                            ></bc-autocomplete>
                                        </v-flex>
                                        <v-flex xs6>
                                            <h3><strong>Request to Production</strong></h3>
                                        </v-flex>
                                        <v-flex xs6>
                                            <h3>
                                                <strong
                                                    v-if="
                                                        nonconformance_hold_tag.nine_point_submission == '1' ||
                                                        nonconformance_hold_tag.strip_chart == '1' ||
                                                        nonconformance_hold_tag.recipe_sheet == '1' ||
                                                        nonconformance_hold_tag.process_sheet == '1'
                                                    "
                                                    >Production Dept. use only</strong
                                                >
                                            </h3>
                                        </v-flex>
                                        <v-flex xs6>
                                            <bc-select
                                                v-model="nonconformance_hold_tag.nine_point_submission"
                                                :label="`${$t('lang.nine_point_submission')} *`"
                                                :items="[
                                                    { value: '1', text: $t('lang.yes') },
                                                    { value: '0', text: $t('lang.no') },
                                                ]"
                                                item-value="value"
                                                item-text="text"
                                                :rules="ifValid('nonconformance_hold_tags.nine_point_submission')"
                                                @change="setNull(nonconformance_hold_tag, ['nine_point_submission_date', 'nine_point_submission_by'])"
                                            >
                                            </bc-select>
                                        </v-flex>
                                        <v-flex xs3>
                                            <bc-date-picker
                                                v-if="nonconformance_hold_tag.nine_point_submission == '1'"
                                                v-model="nonconformance_hold_tag.nine_point_submission_date"
                                                :label="$t('lang.date')"
                                                :rules="ifValid('nonconformance_hold_tags.nine_point_submission_date')"
                                            ></bc-date-picker>
                                        </v-flex>
                                        <v-flex xs3>
                                            <bc-autocomplete
                                                v-if="nonconformance_hold_tag.nine_point_submission == '1'"
                                                v-model="nonconformance_hold_tag.nine_point_submission_by"
                                                :label="$t('lang.by')"
                                                :items="people_options"
                                                item-value="user_id"
                                                item-text="combined_name"
                                                :rules="ifValid('nonconformance_hold_tags.nine_point_submission_by')"
                                            ></bc-autocomplete>
                                        </v-flex>
                                        <v-flex xs6>
                                            <bc-select
                                                v-model="nonconformance_hold_tag.strip_chart"
                                                :label="`${$t('lang.strip_chart')} *`"
                                                :items="[
                                                    { value: '1', text: $t('lang.yes') },
                                                    { value: '0', text: $t('lang.no') },
                                                ]"
                                                item-value="value"
                                                item-text="text"
                                                :rules="ifValid('nonconformance_hold_tags.strip_chart')"
                                                @change="setNull(nonconformance_hold_tag, ['strip_chart_date', 'strip_chart_by'])"
                                            >
                                            </bc-select>
                                        </v-flex>
                                        <v-flex xs3>
                                            <bc-date-picker
                                                v-if="nonconformance_hold_tag.strip_chart == '1'"
                                                v-model="nonconformance_hold_tag.strip_chart_date"
                                                :label="$t('lang.date')"
                                                :rules="ifValid('nonconformance_hold_tags.strip_chart_date')"
                                            ></bc-date-picker>
                                        </v-flex>
                                        <v-flex xs3>
                                            <bc-autocomplete
                                                v-if="nonconformance_hold_tag.strip_chart == '1'"
                                                v-model="nonconformance_hold_tag.strip_chart_by"
                                                :label="$t('lang.by')"
                                                :items="people_options"
                                                item-value="user_id"
                                                item-text="combined_name"
                                                :rules="ifValid('nonconformance_hold_tags.strip_chart_by')"
                                            ></bc-autocomplete>
                                        </v-flex>
                                        <v-flex xs6>
                                            <bc-select
                                                v-model="nonconformance_hold_tag.recipe_sheet"
                                                :label="`${$t('lang.recipe_sheet')} *`"
                                                :items="[
                                                    { value: '1', text: $t('lang.yes') },
                                                    { value: '0', text: $t('lang.no') },
                                                ]"
                                                item-value="value"
                                                item-text="text"
                                                :rules="ifValid('nonconformance_hold_tags.recipe_sheet')"
                                                @change="setNull(nonconformance_hold_tag, ['recipe_sheet_date', 'recipe_sheet_by'])"
                                            >
                                            </bc-select>
                                        </v-flex>
                                        <v-flex xs3>
                                            <bc-date-picker
                                                v-if="nonconformance_hold_tag.recipe_sheet == '1'"
                                                v-model="nonconformance_hold_tag.recipe_sheet_date"
                                                :label="$t('lang.date')"
                                                :rules="ifValid('nonconformance_hold_tags.recipe_sheet_date')"
                                            ></bc-date-picker>
                                        </v-flex>
                                        <v-flex xs3>
                                            <bc-autocomplete
                                                v-if="nonconformance_hold_tag.recipe_sheet == '1'"
                                                v-model="nonconformance_hold_tag.recipe_sheet_by"
                                                :label="$t('lang.by')"
                                                :items="people_options"
                                                item-value="user_id"
                                                item-text="combined_name"
                                                :rules="ifValid('nonconformance_hold_tags.recipe_sheet_by')"
                                            ></bc-autocomplete>
                                        </v-flex>
                                        <v-flex xs6>
                                            <bc-select
                                                v-model="nonconformance_hold_tag.process_sheet"
                                                :label="`${$t('lang.process_sheet')} *`"
                                                :items="[
                                                    { value: '1', text: $t('lang.yes') },
                                                    { value: '0', text: $t('lang.no') },
                                                ]"
                                                item-value="value"
                                                item-text="text"
                                                :rules="ifValid('nonconformance_hold_tags.process_sheet')"
                                                @change="setNull(nonconformance_hold_tag, ['process_sheet_date', 'process_sheet_by'])"
                                            >
                                            </bc-select>
                                        </v-flex>
                                        <v-flex xs3>
                                            <bc-date-picker
                                                v-if="nonconformance_hold_tag.process_sheet == '1'"
                                                v-model="nonconformance_hold_tag.process_sheet_date"
                                                :label="$t('lang.date')"
                                                :rules="ifValid('nonconformance_hold_tags.process_sheet_date')"
                                            ></bc-date-picker>
                                        </v-flex>
                                        <v-flex xs3>
                                            <bc-autocomplete
                                                v-if="nonconformance_hold_tag.process_sheet == '1'"
                                                v-model="nonconformance_hold_tag.process_sheet_by"
                                                :label="$t('lang.by')"
                                                :items="people_options"
                                                item-value="user_id"
                                                item-text="combined_name"
                                                :rules="ifValid('nonconformance_hold_tags.process_sheet_by')"
                                            ></bc-autocomplete>
                                        </v-flex>
                                        <v-flex xs6>
                                            <h3><strong>QC Dept. use only</strong></h3>
                                        </v-flex>
                                        <v-flex xs6></v-flex>
                                        <v-flex xs6>
                                            <v-checkbox
                                                v-model="customer_contacted"
                                                label="Customer Contacted"
                                                hide-details
                                                true-value="1"
                                                false-value="0"
                                                @click="setNull(nonconformance_hold_tag, ['customer_contacted_date', 'customer_contacted_by'])"
                                            ></v-checkbox>
                                        </v-flex>
                                        <v-flex xs3>
                                            <bc-date-picker
                                                v-if="customer_contacted == '1'"
                                                v-model="nonconformance_hold_tag.customer_contacted_date"
                                                :label="$t('lang.date')"
                                                :rules="ifValid('nonconformance_hold_tags.customer_contacted_date')"
                                            ></bc-date-picker>
                                        </v-flex>
                                        <v-flex xs3>
                                            <bc-autocomplete
                                                v-if="customer_contacted == '1'"
                                                v-model="nonconformance_hold_tag.customer_contacted_by"
                                                :label="$t('lang.by')"
                                                :items="people_options"
                                                item-value="user_id"
                                                item-text="combined_name"
                                                :rules="ifValid('nonconformance_hold_tags.customer_contacted_by')"
                                            ></bc-autocomplete>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn v-if="nonconformance_hold_tag.hold_tag_id != ''" color="primary" @click="showHoldTagPrinter(nonconformance_hold_tag.hold_tag_id)"
                        >Print</v-btn
                    >
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="closeNonconformanceHoldTagDialog()">{{ $t("lang.cancel") }}</v-btn>
                    <v-btn color="success" @mouseup.left="saveNonconformanceHoldTags()">{{ $t("lang.save") }}</v-btn>
                </v-card-actions>
            </v-card>
        </bc-dialog>
        <delete-confirmation-dialog
            ref="delete_scrap_authorizations"
            :heading="$t('lang.delete_scrap_authorization')"
            :message="$t('lang.confirm_delete_message')"
            @onConfirm="deleteScrapAuthorizations(scrap_authorization.scrap_auth_id)"
        ></delete-confirmation-dialog>
        <delete-confirmation-dialog
            ref="delete_nonconformance"
            :heading="$t('lang.delete_nonconformance')"
            :message="$t('lang.confirm_delete_message')"
            @onConfirm="modifyNonconformance('delete', currObjField('nonconformance_id'))"
        ></delete-confirmation-dialog>
        <bc-modal-print ref="print" @close-method="(file_name = null), $refs.print.close()" :file-name="file_name" :no-button="true"></bc-modal-print>
    </div>
</template>
<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";
import AppConfig from "Constants/AppConfig";

import { customersProfileComponents } from "Modules/companies/customers/components/profile.data.js";
import { relativeTimeThreshold } from "moment";

export default {
    data() {
        return {
            subComponentsMap: {},
            subComponents: customersProfileComponents,
            selectedComponent: "users",
            component: null,
            tabs: [
                { title: "people", name: "users" },
                { title: "parts", name: "parts", perms: ["parts.read"] },
                { title: "settings", name: "settings", perms: ["packing_lists.read"] },
            ],
            validPhone: false,
            dbChangedStatus: _.debounce(this.changeStatus, 1500, { maxWait: 1500, leading: true, trailing: false }),
            addList: [
                { title: this.$t("lang.addNumber"), action: "showPhone", ref: "phoneDialog", icon: "phone" },
                { title: this.$t("lang.addAddress"), action: "showAddress", ref: "addressDialog", icon: "location_on" },
            ],
            mobileList: [
                { title: this.$t("lang.addNumber"), action: "showPhone", ref: "phoneDialog", perms: ["companies.update"] },
                { title: this.$t("lang.addAddress"), action: "showAddress", ref: "addressDialog", perms: ["companies.update"] },
                { title: this.$t("lang.refresh"), action: "dbGetCustomer" },
            ],
            customer_dialog: false,
            formData: {},
            customer: {},
            ship_label_types: [
                { name: "normal", display: "Normal" },
                { name: "adi", display: "ADI" },
                { name: "magna", display: "Magna" },
            ],
            status_loader: false,
            file: "",
            newFile: {
                logo_file: "",
            },
            growText: 0,
            updatePhoto: 0,
            errorImg: AppConfig.defaultProfileLogo,
            showErrorImg: false,
            ship_label_type_display: "",
            nonconformance: {
                nonconformance_id: "",
                nonconformance_type_id: "",
                nonconformance_qty: "",
                description: "",
                reason_code_id: "",
                charge: "",
                created_by: "",
                editable: "",
                stop_loading: "",
                notify_supervisor: "",
                not_notified_reason: "",
                supervisor_name: "",
                fc: "",
                not_fc_reason: "",
                qc_hold: "",
                not_qc_reason: "",
                prod_shift_super: "",
                prod_super: "",
                prod_asst_mgr: "",
                prod_mgr: "",
                qc_mgr: "",
            },
            scrap_authorization: {
                scrap_auth_id: null,
                nonconformance_id: null,
                batch_id: null,
                company_id: null,
                part_id: null,
                corrective_action: "0",
                car_number: null,
                quality_mgr_id: null,
                quality_mgr_date: null,
                sales_mgr_id: null,
                sales_mgr_date: null,
                ehs_mgr_id: null,
                ehs_mgr_date: null,
                production_mgr_id: null,
                production_mgr_date: null,
                executive_id: null,
                executive_date: null,
                qty_scrapped: null,
                rma_number: null,
                part_cost_estimate: null,
            },
            scrap_authorization_dialog: false,
            nonconformance_hold_tag: {
                hold_tag_id: "",
                nonconformance_id: "",
                verified_date: "",
                verified_by: "",
                nine_point_submission: "",
                nine_point_submission_date: "",
                nine_point_submission_by: "",
                strip_chart: "",
                strip_chart_date: "",
                strip_chart_by: "",
                recipe_sheet: "",
                recipe_sheet_date: "",
                recipe_sheet_by: "",
                process_sheet: "",
                process_sheet_date: "",
                process_sheet_by: "",
                customer_contacted: "",
                customer_contacted_date: "",
                customer_contacted_by: "",
            },
            file_name: "",
            nonconformance_hold_tag_dialog: false,
            current_obj: {},
            nonconformance_dialog: false,
            current_nonconformance: {},
            qc_verified: "0",
            customer_contacted: "0",
        };
    },
    computed: {
        ...mapState({
            rules_nonconformance: (state) => state.validation.rules_nonconformance,
            nonconformance_types: (state) => state.nonconformance.nonconformance_types,
            people_options: (state) => state.people.person_options,
            rules_scrap_authorizations: (state) => state.scrap_authorizations.rules_scrap_authorizations,
            rules_nonconformance_hold_tags: (state) => state.nonconformance_hold_tags.rules_nonconformance_hold_tags,
        }),
        currObjField() {
            return (field) => {
                return this.current_nonconformance && field && this.current_nonconformance[field] ? this.current_nonconformance[field] : "";
            };
        },
    },
    beforeRouteEnter(to, from, next) {
        store
            .dispatch("fetchNonconformance", {
                url: "nonconformance/" + to.params.id,
                method: "get",
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.nonconformance) {
                    next((vm) => {
                        vm.nonconformance = vm.assignObj2(data.nonconformance, vm.rules_nonconformance);
                        vm.finishLoader();
                    });
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteUpdate(to, from, next) {
        this.$store
            .dispatch("fetchNonconformance", {
                url: "nonconformance/" + to.params.id,
                method: "get",
            })
            .then((data) => {
                if (typeof data !== "undefined" && data.nonconformance) {
                    this.nonconformance = this.assignObj2(data.nonconformance, this.rules_nonconformance);
                    this.finishLoader();
                    next();
                } else {
                    next({ name: "dashboard", replace: true });
                }
            });
    },
    beforeRouteLeave(to, from, next) {
        this.$store.commit("resetPeople");
        this.$store.commit("resetParts");
        next();
    },
    methods: {
        ...mapActions([
            "fetchCustomer",
            "saveCustomer",
            "deleteCustomer",
            "fetchCurrencies",
            "fetchPaymentTerms",
            "fetchOptions",
            "fetchScrapAuthorization",
            "fetchPeople",
            "printScrapAuthorization",
            "saveScrapAuthorization",
            "saveNonconformanceHoldTag",
            "fetchNonconformanceHoldTag",
            "printNonconformanceHoldTag",
            "printNonconformances",
        ]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        modifyNonconformance(method = null, id = null) {
            let body = this.prepForm(this.current_nonconformance, this.rules_nonconformance);
            if (method) {
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (method == "delete" || this.validateForm("nonconformance")) {
                        if (this.repackDetailId) this.nonconformance.repack_detail_id = this.repackDetailId;
                        this.$store.commit("toggleModalLoader", true);
                        this.$store
                            .dispatch("fetchNonconformance", {
                                pk: "nonconformance_id",
                                id: id,
                                url: `nonconformance/${id ? id : ""}`,
                                method: method,
                                stateProperty: this.stateProperty ? this.stateProperty : "nonconformances",
                                dataProperty: "nonconformance",
                                body: body,
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    this.closeNonconformanceDialog();

                                    // if (this.repackDetailId) {
                                    //     let details = this.current_repack.repack_details;
                                    //     let update_index = (details || []).findIndex((obj) => obj.repack_detail_id == this.repackDetailId);
                                    //     if (update_index >= 0) {
                                    //         // update detail row
                                    //         details[update_index].total_removed = `${
                                    //             +details[update_index].total_removed + +this.nonconformance.nonconformance_qty
                                    //         }`;
                                    //         details[update_index].qty = `${+details[update_index].qty - +this.nonconformance.nonconformance_qty}`;
                                    //         this.$store.commit("commitRepack", {
                                    //             property: "repack.repack_details",
                                    //             with: details,
                                    //         });
                                    //         // update list view
                                    //         if ((this.packages || []).length > 0) {
                                    //             this.$store.commit("mutateRepack", {
                                    //                 pk: "repack_id",
                                    //                 id: details[update_index].repack_id,
                                    //                 method: "patch",
                                    //                 property: "packages",
                                    //                 with: {
                                    //                     repack_qty: `${+details[update_index].qty - +this.nonconformance.nonconformance_qty}`,
                                    //                 },
                                    //             });
                                    //         }
                                    //     }
                                    // }
                                    this.refresh(true);
                                } else {
                                    this.$store.commit("toggleModalLoader", false);
                                }
                            });
                    }
                });
            }
        },
        closeNonconformanceDialog() {
            this.nonconformance_dialog = false;
            this.$store.commit("validationOff");
            this.$store.commit("toggleModalLoader", false);
            if (this.$refs.delete_nonconformance) this.$refs.delete_nonconformance.close();
        },
        getNonconformanceTypes() {
            this.$store.dispatch("fetchNonconformance", {
                url: "nonconformance_types",
                method: "get",
                stateProperty: "nonconformance_types",
                commit: true,
            });
        },
        showNonconformance(item = null) {
            // if (this.$refs.nonconformance) this.$refs.nonconformance.reset();
            if (item) this.current_nonconformance = this.assignObj2(item, this.rules_nonconformance);

            if (this.nonconformance_types == null) this.getNonconformanceTypes();

            this.nonconformance_dialog = true;

            this.$nextTick(() => {
                if (item == null) {
                    this.nonconformance.object_name = this.entity_object;
                    this.nonconformance.object_id = this.entity_id;
                }

                if (this.people_options.length == 0) this.fetchPeople({ body: { options: 1, login_type: 1, has_user_account: 1 } });
            });
        },
        changeStatus() {
            this.status_loader = true;
            let status = this.customer.status == 1 ? 0 : 1;
            let body = { company_id: `${this.$route.params.id}`, status: status };

            this.saveCustomer({
                body: body,
            }).then((data) => {
                if (typeof data != "undefined" && data.customer) {
                    this.customer = this.assignObj2(data.customer, this.rules_customers);
                    this.status_loader = false;
                    this.finishLoader();
                }
            });
        },
        getScrapAuthorization(id, showDialog = true) {
            if (id != null) {
                this.fetchScrapAuthorization({
                    id: id,
                }).then((data) => {
                    if (typeof data !== "undefined" && data.scrap_authorization) {
                        this.scrap_authorization = this.assignObj2(data.scrap_authorization, this.rules_scrap_authorizations);
                        if (showDialog == true) this.scrap_authorization_dialog = true;
                        this.toggleModalLoader(false);
                        this.validationOff();
                    }
                });
            } else {
                if (showDialog == true) this.scrap_authorization_dialog = true;
                // this.$refs.form_scrap_authorization.reset();
            }
        },
        saveScrapAuthorizations() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_scrap_authorization")) {
                    let body = this.prepForm(this.scrap_authorization, this.rules_scrap_authorizations);
                    body.nonconformance_id = this.nonconformance.nonconformance_id;
                    this.saveScrapAuthorization({
                        body: body,
                    }).then((data) => {
                        if (typeof data != "undefined" && data.scrap_authorization) {
                            this.closeScrapAuthorizationDialog();
                            this.refresh(true);
                        } else {
                        }
                    });
                }
            });
        },
        closeScrapAuthorizationDialog() {
            this.scrap_authorization_dialog = false;
            this.$refs.delete_scrap_authorizations.close();
            this.validationOff();
            this.toggleModalLoader(false);
        },
        showScrapAuthPrinter(auth_id) {
            // this.startLoader();
            this.$refs.print.openDialog();

            this.printScrapAuthorization({ id: auth_id }).then((data) => {
                if (typeof data != "undefined" && data.scrap_authorization) {
                    this.file_name = data.scrap_authorization.file_name;
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        showNonconformanceHoldTag(getHoldTag = false, showDialog = true) {
            if (getHoldTag) {
                this.fetchNonconformanceHoldTag({ id: this.nonconformance.hold_tag_id }).then((data) => {
                    if (data && data.nonconformance_hold_tags) {
                        this.nonconformance_hold_tag = this.assignObj2(data.nonconformance_hold_tags, this.rules_nonconformance_hold_tags);
                        if (this.nonconformance_hold_tag.customer_contacted_by != null) {
                            this.customer_contacted = "1";
                        }
                        if (this.nonconformance_hold_tag.verified_by != null) {
                            this.qc_verified = "1";
                        }
                        if (showDialog) this.nonconformance_hold_tag_dialog = true;
                        if (this.nonconformance_hold_tag.nonconformance_id == "" || this.nonconformance_hold_tag.nonconformance_id == null) {
                            this.nonconformance_hold_tag.nonconformance_id = this.nonconformance.nonconformance_id;
                        }
                        if (this.people_options.length == 0) this.fetchPeople({ body: { options: 1, login_type: 1, has_user_account: 1 } });
                    }
                });
            } else {
                if (showDialog) this.nonconformance_hold_tag_dialog = true;
                // this.$refs.form_nonconformance_hold_tag.reset();
            }
        },
        closeNonconformanceHoldTagDialog() {
            this.nonconformance_hold_tag_dialog = false;
            this.$store.commit("validationOff");
            this.$store.commit("toggleModalLoader", false);
        },
        saveNonconformanceHoldTags() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_nonconformance_hold_tag")) {
                    let body = this.prepForm(this.nonconformance_hold_tag, this.rules_nonconformance_hold_tags);
                    body.nonconformance_id = this.nonconformance.nonconformance_id;
                    this.saveNonconformanceHoldTag({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            this.closeNonconformanceHoldTagDialog();
                            this.refresh(true);
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        showHoldTagPrinter(hold_tag) {
            // this.startLoader();
            this.$refs.print.openDialog();

            this.printNonconformanceHoldTag({ id: hold_tag }).then((data) => {
                if (typeof data != "undefined" && data.hold_tags) {
                    this.file_name = data.hold_tags.file_name;
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        showNonconformancePrinter() {
            // this.startLoader();
            this.$refs.print.openDialog();

            this.printNonconformances({ id: this.$route.params.id }).then((data) => {
                if (typeof data != "undefined" && data.process_sheet) {
                    this.file_name = data.process_sheet.file_name;
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
        refresh(force = false) {
            if (force == true) {
                this.$store
                    .dispatch("fetchNonconformance", {
                        url: "nonconformance/" + this.$route.params.id,
                        method: "get",
                    })
                    .then((data) => {
                        if (typeof data !== "undefined" && data.nonconformance) {
                            this.nonconformance = this.assignObj2(data.nonconformance, this.rules_nonconformance);
                            this.finishLoader();
                        } else {
                            this.$router.push({ name: "dashboard", replace: true });
                        }
                    });
            }

            if (this.people_options.length == 0 || force == true) this.fetchPeople({ body: { options: 1, login_type: 1, has_user_account: 1 } });

            if (this.nonconformance.hold_tag_id || force == true) {
                this.showNonconformanceHoldTag(true, false);
            }

            if (this.nonconformance.scrap_auth_id || force == true) {
                this.getScrapAuthorization(this.nonconformance.scrap_auth_id, false);
            }
        },
        setNull(obj, values) {
            for (let i = 0; i < values.length; i++) {
                obj[values[i]] = null;
            }
        },
    },
    mounted() {
        this.refresh();
    },
};
</script>
